import Swiper from 'swiper';

const moduleName = 'partners';

export function partners() {

    Array.from(document.querySelectorAll('.js-partners')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const partners = self;
        const partnersSlider = partners.querySelector('.js-partners-slider');
        const partnersPagination = partners.querySelector('.js-partners-pagination');
        const partnersSlides = partners.querySelectorAll('.js-partners-slide');

        togglePagination();

        const partnersSwiper = new Swiper(partnersSlider, {
            slidesPerView: 5,
            slidesPerGroup: 5,
            simulateTouch: false,
            slideActiveClass: '_active',
            pagination: {
                el: partnersPagination,
                clickable: true,
                bulletClass: 'pagination__bullet',
                bulletActiveClass: '_active'
            },
            navigation: {
                nextEl: '.js-partners-next-button',
                prevEl: '.js-partners-prev-button',
            },
            breakpoints: {
                431: {
                    slidesPerView: 1,
                    slidesPerGroup: 1
                },
                567: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                903: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                1129: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            },
            on: {
                resize: togglePagination
            }
        });



        function togglePagination() {
            const windowWidth = document.body.clientWidth;

            if (windowWidth < 432) {
                if (partnersSlides.length > 1) {
                    partnersPagination.classList.remove('_hidden');
                } else {
                    partnersPagination.classList.add('_hidden');
                }
            } else if (windowWidth < 568) {
                if (partnersSlides.length > 2) {
                    partnersPagination.classList.remove('_hidden');
                } else {
                    partnersPagination.classList.add('_hidden');
                }
            } else if (windowWidth < 904) {
                if (partnersSlides.length > 3) {
                    partnersPagination.classList.remove('_hidden');
                } else {
                    partnersPagination.classList.add('_hidden');
                }
            } else if (windowWidth < 1130) {
                if (partnersSlides.length > 4) {
                    partnersPagination.classList.remove('_hidden');
                } else {
                    partnersPagination.classList.add('_hidden');
                }
            } else {
                if (partnersSlides.length > 5) {
                    partnersPagination.classList.remove('_hidden');
                } else {
                    partnersPagination.classList.add('_hidden');
                }
            }
        }
    });

}